import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";

export const deleteCampaign = async (props: { token: string; id: string }) => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/campaigns/${props.id}`;
  return axios.delete(url, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  });
};

export const useDeleteCampaign = () => useMutation(deleteCampaign);
